(() => {
  'use strict';
  const root = document.getElementById('rl-bundle');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const products = JSON.parse(root.querySelector('[data-bundle-products]').textContent);
  const variants = new Map(products.flatMap(p => p.variants.map(v => [String(v.id), {...v, product: p}])));
  const key = 'raeliv-seven-selection-v1';
  let selected = {};
  let busy = false;
  const status = root.querySelector('[data-bundle-status]');
  const submit = root.querySelector('[data-bundle-submit]');
  const cards = [...root.querySelectorAll('[data-product-id]')];
  const count = () => Object.values(selected).reduce((sum, qty) => sum + qty, 0);
  const save = () => { try { sessionStorage.setItem(key, JSON.stringify(selected)); } catch (_) {} };
  const restore = () => {
    try { selected = JSON.parse(sessionStorage.getItem(key) || '{}'); } catch (_) { selected = {}; }
    // Validate restored options against current collection and inventory.
    let remaining = 7;
    const valid = {};
    Object.entries(selected).forEach(([id, qty]) => {
      const v = variants.get(id);
      if (!v || !v.available || !Number.isInteger(qty) || qty < 1) return;
      const allowed = Math.min(qty, v.limit, remaining);
      if (allowed > 0) { valid[id] = allowed; remaining -= allowed; }
    });
    selected = valid;
    cards.forEach(card => {
      const p = products.find(p => String(p.id) === card.dataset.productId);
      const chosen = p.variants.find(v => selected[String(v.id)]);
      if (chosen) card.querySelector('select').value = String(chosen.id);
    });
  };
  function render() {
    const total = count();
    root.querySelector('[data-bundle-progress]').textContent = `${total} of 7 selected · $77`;
    root.querySelector('[data-selected-count]').textContent = total;
    root.querySelector('[data-bundle-meter]').value = total;
    submit.disabled = busy || total !== 7;
    const list = root.querySelector('[data-selected-list]');
    list.replaceChildren();
    Object.entries(selected).forEach(([id, qty]) => {
      const v = variants.get(id);
      const li = document.createElement('li');
      const label = document.createElement('span');
      label.textContent = `${qty} × ${v.product.title}${v.title === 'Default Title' ? '' : ' · ' + v.title}`;
      const remove = document.createElement('button');
      remove.type = 'button'; remove.textContent = 'Remove'; remove.disabled = busy;
      remove.setAttribute('aria-label', `Remove ${v.product.title} ${v.title}`);
      remove.addEventListener('click', () => adjust(id, -1));
      li.append(label, remove); list.append(li);
    });
    if (!total) { const li = document.createElement('li'); li.textContent = 'Your chosen pieces will appear here.'; list.append(li); }
    cards.forEach(card => {
      const id = card.querySelector('select').value;
      const v = variants.get(id);
      const qty = selected[id] || 0;
      card.querySelector('[data-card-count]').textContent = qty;
      card.querySelector('[data-add]').disabled = busy || total >= 7 || !v?.available || qty >= v.limit;
      card.querySelector('[data-remove]').disabled = busy || qty === 0;
      card.classList.toggle('is-selected', products.find(p => String(p.id) === card.dataset.productId).variants.some(v => selected[String(v.id)]));
    });
    save();
  }
  function adjust(id, delta) {
    if (busy) return;
    const v = variants.get(id); const next = (selected[id] || 0) + delta;
    if (!v || !v.available || next < 0 || next > v.limit || (delta > 0 && count() >= 7)) return;
    if (next) selected[id] = next; else delete selected[id];
    status.textContent = ''; render();
  }
  cards.forEach(card => {
    const select = card.querySelector('select');
    card.querySelector('[data-add]').addEventListener('click', () => adjust(select.value, 1));
    card.querySelector('[data-remove]').addEventListener('click', () => adjust(select.value, -1));
    select.addEventListener('change', () => {
      const v = variants.get(select.value); const img = card.querySelector('img');
      if (v?.image && img) { img.src = v.image; img.removeAttribute('srcset'); }
      render();
    });
  });
  submit.addEventListener('click', async () => {
    if (busy || count() !== 7) return;
    busy = true; status.textContent = ''; submit.textContent = 'Adding your seven pieces…'; render();
    const base = window.Shopify?.routes?.root || '/';
    try {
      // Match KEFI's existing mix-and-match line property exactly.
      const items = Object.entries(selected).map(([id, quantity]) => ({id: Number(id), quantity, properties: {__KF: {mx: {fi: '6ac574e041aaff782489588e'}}}}));
      const response = await fetch(base + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'A selected option is no longer available. Please check your pieces and try again.');
      selected = {}; save();
      window.location.assign(base + 'cart');
    } catch (error) {
      status.textContent = error.message || 'We could not add your bundle. Please try again.';
      status.scrollIntoView({block:'center',behavior:'smooth'});
      busy = false; submit.textContent = 'Add all 7 for $77'; render();
    }
  });
  restore(); render();
  window.addEventListener('pageshow', () => { restore(); busy = false; submit.textContent = 'Add all 7 for $77'; render(); });
})();
